const products = [
  {
    image: '/pet_images/Bob_Martin_Dog_Tick_Flea_Shampoo_200ml.jpg',
    id: 'Bob_Martin_Dog_Tick_Flea_Shampoo_200ml',
    name: 'Bob Martin Dog Tick & Flea Shampoo 200ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 200.0,
    price: 124.99,
    category: 'Tick & Flea',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'No',
    sterilised: 'No',
    productSize: '200ml',
    description: 'Bob Martin Dog Tick & Flea Shampoo 200ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608492464',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Shampoo',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86065M',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Non_Irritant_Puppy_Shampoo_200ml.jpg',
    id: 'Bob_Martin_Non_Irritant_Puppy_Shampoo_200ml',
    name: 'Bob Martin Non-Irritant Puppy Shampoo 200ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 200.0,
    price: 72.99,
    category: 'Grooming',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Grooming',
    size: 'No',
    sterilised: 'No',
    productSize: '200ml',
    description: 'Bob Martin Non-Irritant Puppy Shampoo 200ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608494444',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Shampoo',
      product_feature: 'Conditioning',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86066',
      colour: ''
    },
  },
  {
    image: '/pet_images/BOB_MARTIN_Conditioning_Shampoo_200ml.jpg',
    id: 'BOB_MARTIN_Conditioning_Shampoo_200ml',
    name: 'BOB MARTIN Conditioning Shampoo 200ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 200.0,
    price: 59.00,
    category: 'Grooming',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Grooming',
    size: 'No',
    sterilised: 'No',
    productSize: '200ml',
    description: 'BOB MARTIN Conditioning Shampoo 200ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608492488',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Shampoo',
      product_feature: 'Conditioning',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86067',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Dog_Tick_Flea_Dog_Dip_100ml.jpg',
    id: 'Bob_Martin_Dog_Tick_Flea_Dog_Dip_100ml',
    name: 'Bob Martin Dog Tick & Flea Dog Dip 100ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 100.0,
    price: 178.99,
    category: 'Tick & Flea',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'No',
    sterilised: 'No',
    productSize: '100ml',
    description: 'Bob Martin Dog Tick & Flea Dog Dip 100ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608492501',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dip',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86068',
      colour: ''
    },
  },
  {
    image: '/pet_images/BOB_MARTIN_CLEAR_3_IN_1_DEWORMER_SMALL_MEDIUM_DOGS_15mg.jpg',
    id: 'BOB_MARTIN_CLEAR_3_IN_1_DEWORMER_SMALL_MEDIUM_DOGS_15mg',
    name: 'BOB MARTIN CLEAR+ 3-IN-1 DEWORMER SMALL / MEDIUM DOGS 15mg Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 125.99,
    category: 'Tick, Flea & Deworming',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'small',
    sterilised: 'No',
    productSize: 'Single',
    description: 'BOB MARTIN CLEAR+ 3-IN-1 DEWORMER SMALL / MEDIUM DOGS 15mg Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608492266',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Tablet',
      product_feature: 'Flea, Tick & Worm',
      breed: 'No',
      breed_size: 'small',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86069',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Clear_3_in_1_Dewormer_for_Large_Dogs.jpg',
    id: 'Bob_Martin_Clear_3_in_1_Dewormer_for_Large_Dogs',
    name: 'Bob Martin Clear+ 3-in-1 Dewormer for Large Dogs Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 168.99,
    category: 'Tick, Flea & Deworming',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Deworming',
    size: 'large',
    sterilised: 'No',
    productSize: 'Single',
    description: 'Bob Martin Clear+ 3-in-1 Dewormer for Large Dogs Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6001462000168',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Tablet',
      product_feature: 'Flea, Tick & Worm',
      breed: 'No',
      breed_size: 'large',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86070',
      colour: ''
    },
  },
  {
    image: '/pet_images/BOB_MARTIN_NATURALS_CALMCARE_SPOT_ON_FOR_DOGS_PUPPIES.jpg',
    id: 'BOB_MARTIN_NATURALS_CALMCARE_SPOT_ON_FOR_DOGS_PUPPIES',
    name: 'BOB MARTIN NATURALS CALMCARE SPOT ON FOR DOGS & PUPPIES Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 220.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Calming',
    size: 'No',
    sterilised: 'No',
    productSize: 'Single',
    description: 'BOB MARTIN NATURALS CALMCARE SPOT ON FOR DOGS & PUPPIES Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608499111',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Spot-on',
      product_feature: 'Calming',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86090',
      colour: ''
    },
  },
  {
    image: '/pet_images/BOB_MARTIN_NATURALS_CALMCARE_SPOT_ON_FOR_CATS_KITTENS.jpg',
    id: 'BOB_MARTIN_NATURALS_CALMCARE_SPOT_ON_FOR_CATS_KITTENS',
    name: 'BOB MARTIN NATURALS CALMCARE SPOT ON FOR CATS & KITTENS Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 209.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Calming',
    size: 'No',
    sterilised: 'No',
    productSize: 'Single',
    description: 'BOB MARTIN NATURALS CALMCARE SPOT ON FOR CATS & KITTENS Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608499128',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Spot-on',
      product_feature: 'Calming',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86091',
      colour: ''
    },
  },
  {
    image: '/pet_images/BOB_MARTIN_NATURALS_CALMCARE_COLLAR_FOR_DOGS_PUPPIES.jpg',
    id: 'BOB_MARTIN_NATURALS_CALMCARE_COLLAR_FOR_DOGS_PUPPIES',
    name: 'BOB MARTIN NATURALS CALMCARE COLLAR FOR DOGS & PUPPIES Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 215.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Calming',
    size: 'No',
    sterilised: 'No',
    productSize: 'Single',
    description: 'BOB MARTIN NATURALS CALMCARE COLLAR FOR DOGS & PUPPIES Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608499135',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Collar',
      product_feature: 'Calming',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86092',
      colour: ''
    },
  },
  {
    image: '/pet_images/BOB_MARTIN_NATURALS_CALMCARE_COLLAR_FOR_CATS_KITTENS.jpg',
    id: 'BOB_MARTIN_NATURALS_CALMCARE_COLLAR_FOR_CATS_KITTENS',
    name: 'BOB MARTIN NATURALS CALMCARE COLLAR FOR CATS & KITTENS Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 244.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Calming',
    size: 'No',
    sterilised: 'No',
    productSize: 'Single',
    description: 'BOB MARTIN Naturals Calmcare Collar for Cats &amp; Kittens effectively assists in reducing problem behaviour arising from stressful situations in cats of all breeds and ages. Using safe, natural ingre',
    longDescription: '<div class="std" itemprop="description">BOB MARTIN Naturals Calmcare Collar for Cats &amp; Kittens effectively assists in reducing problem behaviour arising from stressful situations in cats of all breeds and ages. Using safe, natural ingredients that are slowly released over a period of 4 – 5 weeks, the collar leaves cats feeling calm, settled and relaxed, which assists in reducing problem behaviour. This can be especially important in a multi-cat (or pet) household as cats are particularly sensitive to other animals and changes in their environment. BOB MARTIN Naturals Calmcare Collar for Cats &amp; Kittens contains valerian and lavender, which are often used in human healthcare to manage stress and anxiety and have been proven to help reduce excessive meowing, vertical scratching, scent-marking and other undesirable behaviours in cats. This collar is long-acting, making it effective in assisting in reducing anxiety during the introduction of new additions to the household, frequent travel, vet/cattery stays, thunder (noise) phobias, during party season (particularly when there are fireworks) as well as assisting in the treatment of separation anxiety. Once fitted, Valerian will be released immediately and the cat will begin to relax within approximately one hour.</div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608499142',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Collar',
      product_feature: 'Calming',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86093',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Dog_Fly_Repellent_Spray_200ml.jpg',
    id: 'Bob_Martin_Dog_Fly_Repellent_Spray_200ml',
    name: 'Bob Martin Dog Fly Repellent Spray 200ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 200.0,
    price: 129.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Fly Repellent',
    size: 'No',
    sterilised: 'No',
    productSize: '200ml',
    description: 'Bob Martin Dog Fly Repellent Spray 200ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608491887',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Spray',
      product_feature: 'Fly Repellent',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86100',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Vetcare_Dog_Tick_Flea_Powder_100gm.jpg',
    id: 'Bob_Martin_Vetcare_Dog_Tick_Flea_Powder_100gm',
    name: 'Bob Martin Vetcare Dog Tick & Flea Powder 100gm Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 100.0,
    price: 76.99,
    category: 'Tick & Flea',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'No',
    sterilised: 'No',
    productSize: '100g',
    description: 'Bob Martin Vetcare Dog Tick & Flea Powder 100gm Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608491962',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Powder',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86110M',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Clear_Tick_Flea_Powder_for_Cats_Kittens_100g.jpg',
    id: 'Bob_Martin_Clear_Tick_Flea_Powder_for_Cats_Kittens_100g',
    name: 'Bob Martin Clear+ Tick & Flea Powder for Cats & Kittens 100g Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 100.0,
    price: 76.99,
    category: 'Tick & Flea',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'No',
    sterilised: 'No',
    productSize: '100g',
    description: 'BOB MARTIN Clear Plus Tick &amp; Flea Powder for Cats &amp; Kittens contains Propoxur that is used for the management of ticks and fleas on pets.',
    longDescription: '<div class="std" itemprop="description">BOB MARTIN Clear Plus Tick &amp; Flea Powder for Cats &amp; Kittens contains Propoxur that is used for the management of ticks and fleas on pets.</div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Powder',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86111M',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Tick_Flea_Shampoo_200ml.jpg',
    id: 'Bob_Martin_Tick_Flea_Shampoo_200ml',
    name: 'Bob Martin Tick & Flea Shampoo 200ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 200.0,
    price: 131.99,
    category: 'Tick & Flea',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'No',
    sterilised: 'No',
    productSize: '200ml',
    description: 'BOB MARTIN Clear Plus Tick &amp; Flea shampoo for dogs contains cypermethrin and Piperonyl Butoxide that is used for the management of ticks and fleas on your dog.',
    longDescription: '<div class="std" itemprop="description">BOB MARTIN Clear Plus Tick &amp; Flea shampoo for dogs contains cypermethrin and Piperonyl Butoxide that is used for the management of ticks and fleas on your dog.</div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Shampoo',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86120',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Tick_Flea_Shampoo_400ml.jpg',
    id: 'Bob_Martin_Tick_Flea_Shampoo_400ml',
    name: 'Bob Martin Tick & Flea Shampoo 400ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 400.0,
    price: 209.99,
    category: 'Tick & Flea',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'No',
    sterilised: 'No',
    productSize: '400ml',
    description: 'Bob Martin Tick & Flea Shampoo 400ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608493034',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Shampoo',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86121',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Vetcare_Dog_Tick_Flea_Long_Acting_Spry_200ml.jpg',
    id: 'Bob_Martin_Vetcare_Dog_Tick_Flea_Long_Acting_Spry_200ml',
    name: 'Bob Martin Vetcare Dog Tick & Flea Long Acting Spry 200ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 200.0,
    price: 199.99,
    category: 'Tick & Flea',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'No',
    sterilised: 'No',
    productSize: '200ml',
    description: 'Bob Martin Vetcare Dog Tick & Flea Long Acting Spry 200ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608493393',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Spray',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86122',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Dog_Cat_Eczema_Treatment_100ml.jpg',
    id: 'Bob_Martin_Dog_Cat_Eczema_Treatment_100ml',
    name: 'Bob Martin Dog & Cat Eczema Treatment 100ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 100.0,
    price: 201.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Skin Care',
    size: 'No',
    sterilised: 'No',
    productSize: '100ml',
    description: 'Bob Martin Dog & Cat Eczema Treatment 100ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608492006',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Lotion',
      product_feature: 'Eczema',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86130',
      colour: ''
    },
  },
  {
    image: '/pet_images/BOB_MARTIN_Conditioning_Shampoo_with_lavender_oil_200ml.jpg',
    id: 'BOB_MARTIN_Conditioning_Shampoo_with_lavender_oil_200ml',
    name: 'BOB MARTIN Conditioning Shampoo with lavender oil 200ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 200.0,
    price: 59.00,
    category: 'Grooming',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Grooming',
    size: 'No',
    sterilised: 'No',
    productSize: '200ml',
    description: 'BOB MARTIN Conditioning Shampoo with lavender oil 200ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608492105',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Shampoo',
      product_feature: 'Conditioning',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86170',
      colour: 'Lavender'
    },
  },
  {
    image: '/pet_images/Bob_Martin_Dog_Condition_Shampoo_Citronela_200ml.jpg',
    id: 'Bob_Martin_Dog_Condition_Shampoo_Citronela_200ml',
    name: 'Bob Martin Dog Condition Shampoo Citronela 200ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 200.0,
    price: 99.00,
    category: 'Grooming',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Grooming',
    size: 'No',
    sterilised: 'No',
    productSize: '200ml',
    description: 'Looking for a dog shampoo that removes dirt and repels bugs? Bob Martin Natural Citronella Shampoo &amp; Conditioner contains natural citronella oil that soothes the skin, wards off pests, and cleans',
    longDescription: '<div class="std" itemprop="description">Looking for a dog shampoo that removes dirt and repels bugs? Bob Martin Natural Citronella Shampoo &amp; Conditioner contains natural citronella oil that soothes the skin, wards off pests, and cleans and conditions your pup’s coat. Made with non-irritating ingredients in a gentle PH, our shampoo and conditioner combo is ideal for dogs with sensitive skins. Available in 200ml.</div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Shampoo',
      product_feature: 'Conditioning',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86171',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_2_in_1_Dog_Shampoo_Conditioner_400ml.jpg',
    id: 'Bob_Martin_2_in_1_Dog_Shampoo_Conditioner_400ml',
    name: 'Bob Martin 2 in 1 Dog Shampoo & Conditioner 400ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 400.0,
    price: 151.99,
    category: 'Grooming',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Grooming',
    size: 'No',
    sterilised: 'No',
    productSize: '400ml',
    description: 'Bob Martin 2 in 1 Dog Shampoo & Conditioner 400ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608493614',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Shampoo & Conditioner',
      product_feature: 'Conditioning',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86172',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Dog_Shampoo_amp_Conditioner_Teatree_200ml.jpg',
    id: 'Bob_Martin_Dog_Shampoo_amp_Conditioner_Teatree_200ml',
    name: 'Bob Martin Dog Shampoo &amp; Conditioner Teatree 200ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 200.0,
    price: 73.99,
    category: 'Grooming',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Grooming',
    size: 'No',
    sterilised: 'No',
    productSize: '200ml',
    description: 'Spoil your pooch with a refreshing bath loaded with natural Australian tea tree oil that will soothe irritated and dry skin. Bob Martin Shampoo &amp; Conditioner Teatree is safe and easy to use. Simpl',
    longDescription: '<div class="std" itemprop="description">Spoil your pooch with a refreshing bath loaded with natural Australian tea tree oil that will soothe irritated and dry skin. Bob Martin Shampoo &amp; Conditioner Teatree is safe and easy to use. Simply massage a generous amount into your dog’s coat, rinse it off, and see your pup go from dull and dirty to clean and shiny. Suitable for all adult dogs. Available in 200ml.</div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Shampoo',
      product_feature: 'Conditioning',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86177',
      colour: ''
    },
  },
  {
    image: '/pet_images/BOB_MARTIN_Rinse_Free_Shampoo_200ml.jpg',
    id: 'BOB_MARTIN_Rinse_Free_Shampoo_200ml',
    name: 'BOB MARTIN Rinse Free Shampoo 200ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 200.0,
    price: 99.99,
    category: 'Grooming',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Grooming',
    size: 'No',
    sterilised: 'No',
    productSize: '200ml',
    description: 'BOB MARTIN Rinse Free Shampoo 200ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Foam Shampoo',
      product_feature: 'Conditioning',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86179',
      colour: 'Lavender'
    },
  },
  {
    image: '/pet_images/Bob_Martin_Clear_Fly_Repellent_Ointment_for_Dogs_200ml.jpg',
    id: 'Bob_Martin_Clear_Fly_Repellent_Ointment_for_Dogs_200ml',
    name: 'Bob Martin Clear+ Fly Repellent Ointment for Dogs 200ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 200.0,
    price: 119.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Fly Repellent',
    size: 'No',
    sterilised: 'No',
    productSize: '200ml',
    description: 'Bob Martin Clear+ Fly Repellent Ointment for Dogs 200ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Ointment',
      product_feature: 'Fly Repellent',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86191',
      colour: ''
    },
  },
  {
    image: '/pet_images/BOB_MARTIN_Detangling_Shampoo_with_bamboo_pomegranate_300ml.jpg',
    id: 'BOB_MARTIN_Detangling_Shampoo_with_bamboo_pomegranate_300ml',
    name: 'BOB MARTIN Detangling Shampoo with bamboo & pomegranate 300ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 300.0,
    price: 109.99,
    category: 'Grooming',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Grooming',
    size: 'No',
    sterilised: 'No',
    productSize: '300ml',
    description: 'BOB MARTIN Detangling Shampoo with bamboo & pomegranate 300ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608495274',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Shampoo',
      product_feature: 'Detangling',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86300',
      colour: ''
    },
  },
  {
    image: '/pet_images/BOB_MARTIN_Dry_Skin_Shampoo_with_Exmarid_hydrating_complex_300ml.jpg',
    id: 'BOB_MARTIN_Dry_Skin_Shampoo_with_Exmarid_hydrating_complex_300ml',
    name: 'BOB MARTIN Dry Skin Shampoo with Exmarid™ hydrating complex 300ml Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 300.0,
    price: 109.99,
    category: 'Grooming',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Grooming',
    size: 'No',
    sterilised: 'No',
    productSize: '300ml',
    description: 'BOB MARTIN Dry Skin Shampoo with Exmarid™ hydrating complex 300ml Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608495298',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Shampoo',
      product_feature: 'Dry Skin',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86301',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Nature_Classic_Cat_Litter_2_5kg.jpg',
    id: 'Bob_Martin_Nature_Classic_Cat_Litter_2_5kg',
    name: 'Bob Martin Nature Classic Cat Litter 2.5kg Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2.5,
    price: 39.99,
    category: 'Cat Litter',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Litter',
    size: 'No',
    sterilised: 'No',
    productSize: '2.5kg',
    description: 'Bob Martin Nature Classic Cat Litter 2.5kg Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608493966',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Litter',
      product_feature: 'Odour Control',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86562',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Nature_Classic_Cat_Litter_5kg.jpg',
    id: 'Bob_Martin_Nature_Classic_Cat_Litter_5kg',
    name: 'Bob Martin Nature Classic Cat Litter 5kg Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 5.0,
    price: 74.99,
    category: 'Cat Litter',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Litter',
    size: 'No',
    sterilised: 'No',
    productSize: '5kg',
    description: 'Bob Martin Nature Classic Cat Litter 5kg Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608494055',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Litter',
      product_feature: 'Odour Control',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86564M',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Cat_Litter_Ultra_Fine_5kg.jpg',
    id: 'Bob_Martin_Cat_Litter_Ultra_Fine_5kg',
    name: 'Bob Martin Cat Litter Ultra Fine 5kg Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 5.0,
    price: 87.99,
    category: 'Cat Litter',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Litter',
    size: 'No',
    sterilised: 'No',
    productSize: '5kg',
    description: 'Bob Martin Cat Litter Ultra Fine 5kg Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608494062',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Litter',
      product_feature: 'Odour Control',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86566M',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Kitten_Litter_Baby_Powder_Fragranced_5kg.jpg',
    id: 'Bob_Martin_Kitten_Litter_Baby_Powder_Fragranced_5kg',
    name: 'Bob Martin Kitten Litter Baby Powder Fragranced 5kg Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 5.0,
    price: 69.99,
    category: 'Cat Litter',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Litter',
    size: 'No',
    sterilised: 'No',
    productSize: '5kg',
    description: 'Bob Martin Kitten Litter Baby Powder Fragranced 5kg Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608495526',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Litter',
      product_feature: 'Kitten',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86567M',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Cat_Litter_Fragranced_5kg.jpg',
    id: 'Bob_Martin_Cat_Litter_Fragranced_5kg',
    name: 'Bob Martin Cat Litter Fragranced 5kg Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 5.0,
    price: 59.00,
    category: 'Cat Litter',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Litter',
    size: 'No',
    sterilised: 'No',
    productSize: '5kg',
    description: 'Bob Martin Cat Litter Fragranced 5kg Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608494079',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Litter',
      product_feature: 'Odour Control',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86570M',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Felight_Cat_litter_Antibaterial_Lavendar_Crystals_1_8kg.jpg',
    id: 'Bob_Martin_Felight_Cat_litter_Antibaterial_Lavendar_Crystals_1_8kg',
    name: 'Bob Martin Felight Cat litter Antibaterial Lavendar Crystals 1.8kg Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.8,
    price: 129.99,
    category: 'Cat Litter',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Litter',
    size: 'No',
    sterilised: 'No',
    productSize: '1.8kg',
    description: 'Bob Martin Felight Cat litter Antibaterial Lavendar Crystals 1.8kg Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608494840',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Silica Litter',
      product_feature: 'Odour Control',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86582M',
      colour: 'Lavender'
    },
  },
  {
    image: '/pet_images/Bob_Martin_Felight_Cat_Litter_Antibaterial_Pine_Crystals_1_8kg.jpg',
    id: 'Bob_Martin_Felight_Cat_Litter_Antibaterial_Pine_Crystals_1_8kg',
    name: 'Bob Martin Felight Cat Litter Antibaterial Pine Crystals 1.8kg Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.8,
    price: 129.99,
    category: 'Cat Litter',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Litter',
    size: 'No',
    sterilised: 'No',
    productSize: '1.8kg',
    description: 'Bob Martin Felight Cat Litter Antibaterial Pine Crystals 1.8kg Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608494864',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Silica Litter',
      product_feature: 'Odour Control',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86583',
      colour: 'Pine'
    },
  },
  {
    image: '/pet_images/Bob_Martin_Felight_Eco_Cat_Litter_Corn_4kg.jpg',
    id: 'Bob_Martin_Felight_Eco_Cat_Litter_Corn_4kg',
    name: 'Bob Martin Felight Eco Cat Litter Corn 4kg Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4.0,
    price: 199.99,
    category: 'Cat Litter',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Litter',
    size: 'No',
    sterilised: 'No',
    productSize: '4kg',
    description: 'Bob Martin Felight Eco Cat Litter Corn 4kg Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608499555',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Eco Litter',
      product_feature: 'Eco-Friendly',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-86586',
      colour: 'Corn'
    },
  },
  {
    image: '/pet_images/Bob_Martin_Multicare_Conditioning_Tablets_for_Cats_Kittens_50s.jpg',
    id: 'Bob_Martin_Multicare_Conditioning_Tablets_for_Cats_Kittens_50s',
    name: 'Bob Martin Multicare Conditioning Tablets for Cats & Kittens 50s Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 106.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Joint Care',
    size: 'No',
    sterilised: 'No',
    productSize: 'Single',
    description: 'Bob Martin Multicare Conditioning Tablets for Cats & Kittens 50s Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6001462000007',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Tablet',
      product_feature: 'Joint Care',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-87730',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_MultiCare_Conditioning_Tablets_for_Small_Dogs_Puppies_50_s.jpg',
    id: 'Bob_Martin_MultiCare_Conditioning_Tablets_for_Small_Dogs_Puppies_50_s',
    name: 'Bob Martin MultiCare Conditioning Tablets for Small Dogs & Puppies 50’s Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 154.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Joint Care',
    size: 'small',
    sterilised: 'No',
    productSize: 'Single',
    description: 'Bob Martin MultiCare Conditioning Tablets for Small Dogs & Puppies 50’s Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6001462000014',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Tablet',
      product_feature: 'Joint Care',
      breed: 'No',
      breed_size: 'small',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-87731',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_MultiCare_Conditioning_Tablets_for_Small_Dogs_Puppies_100_s.jpg',
    id: 'Bob_Martin_MultiCare_Conditioning_Tablets_for_Small_Dogs_Puppies_100_s',
    name: 'Bob Martin MultiCare Conditioning Tablets for Small Dogs & Puppies 100’s Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 154.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Joint Care',
    size: 'small',
    sterilised: 'No',
    productSize: 'Single',
    description: 'Bob Martin MultiCare Conditioning Tablets for Small Dogs & Puppies 100’s Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6001462000021',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Tablet',
      product_feature: 'Joint Care',
      breed: 'No',
      breed_size: 'small',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-87732',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Multicare_Conditioning_Tablets_for_Medium_Dogs_50_s.jpg',
    id: 'Bob_Martin_Multicare_Conditioning_Tablets_for_Medium_Dogs_50_s',
    name: 'Bob Martin Multicare Conditioning Tablets for Medium Dogs 50’s Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 109.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Joint Care',
    size: 'medium',
    sterilised: 'No',
    productSize: 'Single',
    description: 'Bob Martin Multicare Conditioning Tablets for Medium Dogs 50’s Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6001462000045',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Tablet',
      product_feature: 'Joint Care',
      breed: 'No',
      breed_size: 'medium',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-87733',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Multicare_Conditioning_Tablets_for_Medium_Dogs_100_s.jpg',
    id: 'Bob_Martin_Multicare_Conditioning_Tablets_for_Medium_Dogs_100_s',
    name: 'Bob Martin Multicare Conditioning Tablets for Medium Dogs 100’s Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 154.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Joint Care',
    size: 'medium',
    sterilised: 'No',
    productSize: 'Single',
    description: 'Bob Martin Multicare Conditioning Tablets for Medium Dogs 100’s Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6001462000052',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Tablet',
      product_feature: 'Joint Care',
      breed: 'No',
      breed_size: 'medium',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-87734',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Multicare_Conditioning_Tablets_for_Large_Dogs_100_s.jpg',
    id: 'Bob_Martin_Multicare_Conditioning_Tablets_for_Large_Dogs_100_s',
    name: 'Bob Martin Multicare Conditioning Tablets for Large Dogs 100’s Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 156.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Joint Care',
    size: 'large',
    sterilised: 'No',
    productSize: 'Single',
    description: 'Bob Martin Multicare Conditioning Tablets for Large Dogs 100’s Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6001462000106',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Tablet',
      product_feature: 'Joint Care',
      breed: 'No',
      breed_size: 'large',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-87736',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Clear_Tick_Flea_Collar_for_Cats.jpg',
    id: 'Bob_Martin_Clear_Tick_Flea_Collar_for_Cats',
    name: 'Bob Martin Clear+ Tick & Flea Collar for Cats Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 129.99,
    category: 'Tick & Flea',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'No',
    sterilised: 'No',
    productSize: 'Single',
    description: 'Bob Martin Clear+ Tick & Flea Collar for Cats Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6001462000175',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Cat',
      featured: 'No',
      product_type: 'Collar',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-87745',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Clear_Tick_Flea_Collar_for_All_Dogs.jpg',
    id: 'Bob_Martin_Clear_Tick_Flea_Collar_for_All_Dogs',
    name: 'Bob Martin Clear+ Tick & Flea Collar for All Dogs Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 124.99,
    category: 'Tick & Flea',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'No',
    sterilised: 'No',
    productSize: 'Single',
    description: 'Bob Martin Clear+ Tick & Flea Collar for All Dogs Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6001462000182',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Collar',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-87746',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Clear_Tick_Flea_Collar_for_Small_Dogs_Puppies.jpg',
    id: 'Bob_Martin_Clear_Tick_Flea_Collar_for_Small_Dogs_Puppies',
    name: 'Bob Martin Clear+ Tick & Flea Collar for Small Dogs & Puppies Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 129.99,
    category: 'Tick & Flea',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Tick & Flea',
    size: 'No',
    sterilised: 'No',
    productSize: 'Single',
    description: 'Bob Martin Clear+ Tick & Flea Collar for Small Dogs & Puppies Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6001462000199',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Collar',
      product_feature: 'Tick & Flea',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-87747',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_ArthriCare_30s.jpg',
    id: 'Bob_Martin_ArthriCare_30s',
    name: 'Bob Martin ArthriCare-30s Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 216.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Joint Care',
    size: 'No',
    sterilised: 'No',
    productSize: 'Single',
    description: 'Bob Martin ArthriCare-30s Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6001462000120',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Tablet',
      product_feature: 'Joint Care',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-87767',
      colour: ''
    },
  },
  {
    image: '/pet_images/BOB_MARTIN_NATURALS_CALMCARE_TABLETS_FOR_DOGS_CATS.jpg',
    id: 'BOB_MARTIN_NATURALS_CALMCARE_TABLETS_FOR_DOGS_CATS',
    name: 'BOB MARTIN NATURALS CALMCARE TABLETS FOR DOGS & CATS Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 207.99,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Calming',
    size: 'No',
    sterilised: 'No',
    productSize: 'Single',
    description: 'BOB MARTIN Naturals Calmcare for Dogs &amp; Cats is a stress and anxiety remedy containing natural ingredients including valerian root, rosemary, chamomile and lavender. These ingredients can be used',
    longDescription: '<div class="std" itemprop="description">BOB MARTIN Naturals Calmcare for Dogs &amp; Cats is a stress and anxiety remedy containing natural ingredients including valerian root, rosemary, chamomile and lavender. These ingredients can be used to relieve anxiety in stressful situations. They also treat insomnia and boost immunity. BOB MARTIN Naturals Calmcare for Dogs &amp; Cats can be given to your pet two days before a stressful event occurs to assist in keeping them calm and relaxed. In the event of an unexpected stressful situation, administer BOB MARTIN Naturals Calmcare for Dogs &amp; Cats. Your pet should begin to relax within approximately 30 minutes. This supplement is intended for dogs and cats that are in a healthy condition. If your dog or cat has a specific disorder or another health condition, please consult a veterinarian before use.</div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608499623',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Tablet',
      product_feature: 'Calming',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-87769',
      colour: ''
    },
  },
  {
    image: '/pet_images/Bob_Martin_Vetcare_Calmcare_Tablets_for_Dogs_Cats.jpg',
    id: 'Bob_Martin_Vetcare_Calmcare_Tablets_for_Dogs_Cats',
    name: 'Bob Martin Vetcare Calmcare Tablets for Dogs & Cats Single',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 195.00,
    category: 'Healthcare',
    brand: 'Bob Martin',
    age: 'Adult',
    breed: '',
    needs: 'Calming',
    size: 'No',
    sterilised: 'No',
    productSize: 'Single',
    description: 'Bob Martin Vetcare Calmcare Tablets for Dogs & Cats Single',
    longDescription: '<div class="std" itemprop="description"><p></p></div>',
    keyBenefits: [],
    feedingGuide: [{weight: '', idealWeight: '', overweight: ''}],
    additionalInfo: {
      barcode: '6009608499296',
      brands: 'Bob Martin',
      brand: 'Bob Martin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Tablet',
      product_feature: 'Calming',
      breed: 'No',
      breed_size: 'No',
      flavour: 'No',
      lifestage: 'Adult',
      size_chart: 'No',
      supplier_code: 'I04-89649M',
      colour: ''
    },
  },
];

export { products as bobmartinProducts };
export default products;